<div class="log-dashlet">
  <span *ngIf="dashlet.description" class="log-dashlet__description">{{ dashlet.description }}</span>

  <div *ngIf="showPause" class="log-dashlet__controls">
    <p-toggleButton
      [(ngModel)]="isPaused"
      onLabel="Paused"
      offLabel="Live"
      onIcon="pi pi-play"
      offIcon="pi pi-pause"
      severity="secondary"
      size="small"
      [style]="{ 'font-size': '0.75rem', padding: '0.25rem' }"
    >
    </p-toggleButton>
  </div>

  <div class="log-dashlet__container">
    <div #scrollableDiv class="log-dashlet__scrollable-container">
      <span #logSpan *ngIf="actionResponse$ | async as actionResponse; else loading" class="log-dashlet__result">{{
        actionResponse['output']
      }}</span>
      <ng-template #loading>
        <div class="p-skeleton log-dashlet__skeleton"></div>
      </ng-template>
    </div>
  </div>
</div>
